export const routes = {
    dashboard: {
        path: "dashboard",
    },
    widgets: {
        path: "widgets",
    },
    templates: {
        path: "templates",
    },
    learn: {
        path: "learn",
    },
    settings: {
        path: "settings",
    },
    onboarding: {
        path: "onboarding",
    },
    upgrade: {
        path: "upgrade",
    },
    headerFooterBuilder: { 
        path: "elementor-hf" 
    },
    onboardingsuccess: { 
        path: "onboardingsuccess" 
    }
}